"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TobaccoUse = exports.Gender = exports.MemberType = void 0;
/**
 * Member type for an app.
 *
 * @public
 * @memberof Member
 */
var MemberType;
(function (MemberType) {
    MemberType["Applicant"] = "primary";
    MemberType["Spouse"] = "spouse";
    MemberType["Child"] = "child";
})(MemberType = exports.MemberType || (exports.MemberType = {}));
/**
 * The gender identifier of a Member.
 *
 * @public
 * @memberof Member
 */
var Gender;
(function (Gender) {
    Gender["Male"] = "m";
    Gender["Female"] = "f";
})(Gender = exports.Gender || (exports.Gender = {}));
/**
 * The tobacco use identifier of a Member.
 *
 * @public
 * @memberof Member
 */
var TobaccoUse;
(function (TobaccoUse) {
    TobaccoUse["Yes"] = "y";
    TobaccoUse["No"] = "n";
})(TobaccoUse = exports.TobaccoUse || (exports.TobaccoUse = {}));
//# sourceMappingURL=Member.js.map